import type { HttpClient, Result } from "../client";
import type { MetadataResponse } from "../types";

export class DatabaseService {
	constructor(private client: HttpClient) {}

	public async getMetadata(): Promise<Result<MetadataResponse>> {
		return this.client.get<MetadataResponse>("/metadata");
	}
}
